import {
  AfterViewChecked,
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-service-type-chart',
  templateUrl: './service-type-chart.component.html',
  standalone: false,
})
export class ServiceTypeChartComponent
  implements OnInit, AfterViewChecked, OnChanges
{
  @Input() data: { [key: string]: number };

  loading: boolean;

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  backgroundColor: string[];

  public pieChartType: ChartType = 'pie' as ChartType;

  public pieChartOptions: ChartConfiguration['options'] = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    layout: {
      padding: {
        top: 5,
        bottom: 5,
        left: 5,
        right: 5,
      },
    },
  };

  public pieChartData: ChartData<'pie'> = {
    labels: [],
    datasets: [
      {
        data: [],
        label: 'Total',
        borderColor: '#0D2B6B',
        hoverBorderColor: '#0D2B6B',
        borderWidth: 1,
        hoverBorderWidth: 1,
        backgroundColor: [
          '#5BC8F5',
          '#1A5BB5',
          '#E8F4FD',
          '#1976D2',
          '#2EE6C8',
          '#1A4DA8',
          '#A8D8F0',
        ],
      },
    ],
  };

  ngOnInit(): void {
    this.loading = true;
  }

  ngAfterViewChecked(): void {
    this.loading = false;
  }

  ngOnChanges(): void {
    if (this.data && Object.keys(this.data).length > 0) {
      this.setChartData();
    }
  }

  get legendItems(): { label: string; color: string }[] {
    const labels = (this.pieChartData.labels as string[]) ?? [];
    const colors =
      (this.pieChartData.datasets[0].backgroundColor as string[]) ?? [];
    return labels.map((label, i) => ({
      label,
      color: colors[i] ?? '#1A5BB5',
    }));
  }

  private setChartData(): void {
    const entries = Object.entries(this.data);

    entries.sort((a, b) => a[0].localeCompare(b[0]));

    const sortedLabels = entries.map(([label]) => label);
    const sortedData = entries.map(([, value]) => value);

    this.pieChartData.labels = sortedLabels;
    this.pieChartData.datasets[0].data = sortedData;
    this.chart?.update();
  }
}
